






















































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { TextInput } from '@/components';
import Uploader from './components/Uploader.vue';
import PickerInput from './components/PickerInput.vue';
import { Button, Dialog, Toast, Popup, Picker, DatetimePicker } from 'vant';
import { FileType } from '@/common/ts/enum';
// import { save } from '@/api/api';
import * as config from './config';
import { getWorkType, getType, getAreas, getSchools, save } from './api';
import { namespace, State } from 'vuex-class';
import { isWeiXin } from '@/common/ts/common';
import qs from 'qs';

Vue.use(Toast)
  .use(Popup)
  .use(Dialog)
  .use(Button)
  .use(Picker)
  .use(DatetimePicker);
@Component({
  components: {
    TextInput,
    Uploader,
    PickerInput,
  },
})
export default class Uploading extends Vue {
  options = config.OPTHINES;
  pointOut = false;
  noButton = true;
  schoolType = false;
  FileType = FileType;
  WorkTypeData = [];
  WorkTypePickerData: any[] = [];
  TypePickerData: any[] = [];
  AreasPickerData: any[] = [];
  coverArr: any[] = [];
  newCoverArr: any[] = [];
  schoolList: any[] = [];
  unionId!: string | null;
  // 需要传的参数
  workType?: any; // 参赛项目
  type?: any; // 参赛组别
  year?: string = ''; // 出生年月日
  class?: any; // 班级
  countyId?: number; // 区县
  sex?: string = ''; // 性别
  school?: string = ''; // 学校
  nameData?: string = ''; // 姓名
  title?: string = ''; // 作品名称
  parentName?: string = ''; // 联络人姓名
  relationship?: string = ''; // 与参赛者关系
  email?: string = ''; // 电子邮箱
  phone?: string = ''; // 联系方式
  address?: string = ''; // 通讯地址
  cover?: string = ''; // 截图
  teacher?: string = ''; // 指导老师
  organization?: string = ''; // 机构
  creativeIdeas?: string = ''; // 创作理念
  @Watch('school')
  onSchoolValueChanged(newVal: any, val: any) {
    if (newVal) {
      this.fetchSchoolData(newVal);
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  confirmWeixin() {
    if (isWeiXin()) {
      if (!window.localStorage.getItem('unionid')) {
        this.$dialog
          .confirm({
            title: '微信登录',
            message: '上传作品前需要进行微信登录',
          })
          .then(() => {
            console.log('确定');
            this.WechatLogin();
          })
          .catch(() => {
            console.log('取消');
          });
        return;
      } else {
        this.unionId = window.localStorage.getItem('unionid');
      }
    } else {
      Dialog.alert({
        title: '友情提示',
        message:
          '请在微信、“重庆发布”、“iChongqing爱重庆”、“光明网重庆频道”、“智慧八方”微信公众号内进行作品上传',
        closeOnClickOverlay: true,
      })
        .then(() => {
          console.log('then');
        })
        .catch(() => {
          console.log('catch');
        });
    }
  }
  async created() {
    const workTypeRes = await getWorkType();
    this.WorkTypePickerData = Object.values(workTypeRes.data);
    const typeRes = await getType();
    this.TypePickerData = Object.values(typeRes.data);
    const areasRes = await getAreas();
    this.AreasPickerData = Object.values(areasRes.data);
    this.$appShareInfo({
      title:
        '这是我参加第六届“紫荆杯”两岸暨港澳青少年书画大赛的作品，请为我点赞！',
      url: window.location.href,
      subtitle:
        '这是我参加第六届“紫荆杯”两岸暨港澳青少年书画大赛的作品，请为我点赞！',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });

    this.$wxShareInfo({
      title:
        '这是我参加第六届“紫荆杯”两岸暨港澳青少年书画大赛的作品，请为我点赞！',
      subtitle:
        '这是我参加第六届“紫荆杯”两岸暨港澳青少年书画大赛的作品，请为我点赞！',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  fetchWorkTypeData(e: string, index: number) {
    this.workType = index + 1;
    console.log('index', index, this.workType);
  }
  fetchTypeData(e: string, index: number) {
    this.type = index + 1;
    console.log('index', index, this.type);
  }
  fetchAreasData(e: string, index: number) {
    this.countyId = index + 1;
    console.log('index', index, this.countyId);
  }
  fetchDateData(e: string, index: number) {
    this.year = e;
  }
  fetchClassData(e: string, index: number) {
    this.class = index + 1;
    console.log('index', index, this.class);
  }
  fetchSexData(e: string, index: number) {
    this.sex = e;
  }
  fetchSchoolData(value: any) {
    console.log('fetchSchoolData', value);
    this.schoolType = true;
    getSchools({ search: value }).then((res: any) =>
      this.successSchoolData(res),
    );
  }
  successSchoolData(res: any) {
    this.schoolList = res.data.map((schoolData: any) => schoolData.name);
    // console.log('res', res.data.map(schoolData => schoolData.name),this.schoolList);
  }
  chooseSchool(index: number, school: string) {
    console.log('school：', school);
    this.school = school;
    this.schoolType = false;
  }
  submitCover() {
    this.confirmWeixin();
    if (window.localStorage.getItem('unionid')) {
      (this.$refs.uploaderImage as Uploader).uploadToOss().then((res: any) => {
        console.log('res[0]', res[0]);
        this.cover = res[0];
        // if (!this.cover) {
        //   Toast.fail('请上传图片');
        //   return false;
        // }
      });
    }
  }
  enterSave() {
    this.confirmWeixin();
    if (!window.localStorage.getItem('unionid')) {
      return false;
    }
    if (!this.title) {
      Toast.fail('请输入作品名称');
      return false;
    }
    if (!this.year) {
      Toast.fail('请选择出生日期');
      return false;
    }
    if (!this.sex) {
      Toast.fail('请选择性别');
      return false;
    }
    if (!this.workType) {
      Toast.fail('请选择参赛项目');
      return false;
    }
    if (!this.type) {
      Toast.fail('请选择组别');
      return false;
    }
    if (!this.nameData) {
      Toast.fail('请输入姓名');
      return false;
    }

    if (!this.countyId) {
      Toast.fail('请选择区县');
      return false;
    }
    if (!this.school) {
      Toast.fail('请输入就读学校');
      return false;
    }
    if (!this.class) {
      Toast.fail('请选择班级');
      return false;
    }
    if (!this.parentName) {
      Toast.fail('请输入联络人姓名');
      return false;
    }
    if (!this.relationship) {
      Toast.fail('请输入与参赛者关系');
      return false;
    }
    if (!this.email) {
      Toast.fail('请输入电子邮箱');
      return false;
    }
    if (!this.phone) {
      Toast.fail('请输入联络电话');
      return false;
    }
    if (!this.address) {
      Toast.fail('请输入通讯地址');
      return false;
    }
    setTimeout(() => {
      this.enterSaveNext();
    }, 500);
  }
  async enterSaveNext() {
    // 上传截图
    await (this.$refs.uploaderImage as Uploader)
      .uploadToOss()
      .then((res: any) => {
        console.log('res[0]', res[0]);
        this.cover = res[0];
        if (!this.cover) {
          Toast.fail('请上传作品');
          return false;
        }
      });
    console.log('this.unionId', this.unionId);
    save({
      unionid: this.unionId,
      year: this.year,
      sex: this.sex,
      work_type: this.workType,
      type: this.type,
      class: this.class,
      county: this.countyId,
      school: this.school,
      name: this.nameData,
      title: this.title,
      teacher: this.teacher,
      organization: this.organization,
      parent_name: this.parentName,
      relationship: this.relationship,
      email: this.email,
      phone: this.phone,
      address: this.address,
      cover: this.cover,
      creative_ideas: this.creativeIdeas,
    }).then((res: any) => this.successSave(res));
  }
  successSave(res: any) {
    if (res.code === 101) {
      Toast.fail('信息填写不全！');
    } else if (res.code === 200) {
      Toast.success('提交成功，请等待审核！');
      this.noButton = false;
      setTimeout(() => {
        this.$router.push({ path: 'User', query: { source: '5' } });
      }, 3000);
    } else if (res.code === 203) {
      Toast.fail('请登录后再访问！');
    } else {
      Toast.fail(res.msg);
    }
  }
}
